import { type Enum } from '@webapp/infrastructure/types/Enum'

// What the right-hand detail card can show (Feature-Set-local UI state)
export const ReportAccessDetailPaneStates = {
  LOADING: 'loading', // PrimaryCategory or SecondaryCategory still resolving
  PRIMARY_CATEGORY_ERROR: 'primary-category-error', // the default PrimaryCategory failed to load
  NO_PRIMARY_CATEGORIES: 'no-primary-categories', // the tenant has none
  NO_SECONDARY_CATEGORIES: 'no-secondary-categories', // the PrimaryCategory has none
  SECONDARY_CATEGORIES_ERROR: 'secondary-categories-error', // the SecondaryCategory list failed to load
  NO_SECONDARY_CATEGORY: 'no-secondary-category', // none resolved for any other reason
  READY: 'ready',
} as const

export type ReportAccessDetailPaneStateEnum = Enum<
  typeof ReportAccessDetailPaneStates
>
